module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "dedication"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("DEDICATION")])]), _vm._v(" "), _c('p', {
    staticClass: "dedication1"
  }, [_vm._v("There is a real-life trader in Qolorha, whose name is Rufus Hulley, who took me to places of miracles and untold beauty. He must not be mistaken for John Dalton, the trader of "), _c('em', [_vm._v("The Heart of Redness")]), _vm._v(", who is purely a fictional character. I am grateful to Rufus, and to Jeff Peires, whose research—wonderfully recorded in "), _c('em', [_vm._v("The Dead Will Arise")]), _vm._v(" and in a number of academic papers—informed the historical events in my fiction. As for the people of Qolorha, they will forgive me for reinventing their lives.")]), _vm._v(" "), _c('p', {
    staticClass: "dedication2"
  }, [_vm._v("I wrote this novel in honor of new lives, among which I count my son Zukile, my daughter Zukiswa Zenzile Moroesi, and my daughter’s son, Wandile.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d6dd37b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/dedication.vue
// module id = 69
// module chunks = 0